
import "../styles/home/Section2.css";

const Section2Investor = () => {
  return (
    <section
    style={{ backgroundColor: "white",minHeight: "0px" }}
      className="htmlblock"

    >
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <h2 style={{margin: "0", color: "black"}}>WHY ATTEND COLLISION ?</h2>
          </div>
          <div className="col-md-7" style={{alignItems: "center", color: "black"}}>
            <p>
            Collision brings together the people and companies redefining the global tech industry. Get investor access and engage with expert investors from the world’s most influential funds, and meet the fastest-growing startups. Join us this October.
            </p>
           
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section2Investor;
